<template>
    <!-- 日期类型管理 -->
    <div class="calendar-manger">
        <content-view v-show="$utils.renderWhen(this,'calendar')">
            <a-card>
                <div slot="title">
                    <span @click="pickerBtns()" class="text-primary ml8 mr8 point" style="font-size:24px;position:relative;top:3px;"><a-icon type="left-circle" theme="filled" /></span>
                    <a-month-picker @change="changeMonth" v-if="type === 1" style="width: 105px" format="YYYY-MM" v-model="pickerDate" :allowClear="false"></a-month-picker>
                    <span v-else>{{currentYear}}</span>
                    <span @click="pickerBtns(1)" class="text-primary ml8 point" style="font-size:24px;position:relative;top:3px;"><a-icon type="right-circle" theme="filled" /></span>
                    <a-radio-group class="ml8" :value="type" @change="handleChange">
                        <a-radio-button :value="1">
                            月
                        </a-radio-button>
                        <a-radio-button :value="2">
                            年
                        </a-radio-button>
                    </a-radio-group>
                    <span v-if="type === 2">
                        <a-badge class="ml32" color="blue" text="平日"></a-badge>
                        <a-badge class="ml8 mr8" color="purple" text="高峰日"></a-badge>
                        <a-badge color="orange" text="节假日"></a-badge>
                    </span>
                </div>
                <div slot="extra">
                    <a-button v-if="getBtnByAuth('batchSetDate')" type="primary" @click="$router.push({name:'calendarSet'})">批量设置日期</a-button>
                    <a-button v-if="getBtnByAuth('copyShopCalendar') && shopId != '-1'" type="primary" @click="openCopy">复制门店日历</a-button>
                </div>
                <a-calendar :value="pickerDate" class="totalPlatCalender" v-if="type === 1" @select="selectDate">
                    <div slot="dateCellRender" slot-scope="value">
                        <div v-for="(item,i) in getListData(value)" :key="i">
                            <div v-for="d in item.dateLevels" :key="d">
                                <a-tag :color="d == 'regular' ? 'blue' : d == 'peak' ? 'purple' : 'orange'">{{d == 'regular' ? '平日' : d == 'peak' ? '高峰日' : '节假日'}}</a-tag>
                            </div>
                        </div>
                    </div>
                </a-calendar>
                <div v-else class="year-calendar">
                    <div class="pay-date" v-for="(month,index) in dateList" :key="index">
                        <div>{{index+1}}月</div>
                        <div class="pay-date-weekday flex flex-space-around">
                            <span class="flex" v-for="(item, index) in weekDay" :key="index">{{item}}</span>
                        </div>
                        <div class="pay-date-days flex flex-start flex-wrap">
                            <div class="pay-date-days-item" v-for="(item, i) in month" :key="i" @click="openModal(`${item.year}-${$utils.toDouble(item.month)}-${$utils.toDouble(item.day)}`)">
                                <div class="font22" :class="item.month == (index+1) ? '' : 'text-gray'">{{item.day}}</div>
                                <div v-if="item.month == (index+1)">
                                    <a-badge v-for="(d,j) in item.dateLevels" :key="j" :color="d == 'regular' ? 'blue' : d == 'peak' ? 'purple' : 'orange'"></a-badge>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </a-card>
            <a-modal centered :title="'门店日期类型（'+date+'）'" :visible="visible" :footer="null" @cancel="visible = false" :width="660">
                <a-table
                bordered
                :scroll="{y: 600}"
                :dataSource="dataSource"
                :columns="columns"
                :pagination="false"
                :rowKey="(record,index) => index">
                    <template slot="dateLevel" slot-scope="dateLevel">{{dateLevel == 'regular' ? '平日' : dateLevel == 'peak' ? '高峰日' : '节假日'}}</template>
                    <template slot="action" slot-scope="a,row">
                        <a class="text-primary" @click="row.isShow = false" v-if="row.isShow">编辑</a>
                        <a-radio-group v-model="row.dateLevel" v-else @change="upDateType($event,row)">
                            <a-radio value="regular">平日</a-radio>
                            <a-radio value="peak">高峰日</a-radio>
                            <a-radio value="holiday">节假日</a-radio>
                        </a-radio-group>
                    </template>
                </a-table>
            </a-modal>
            <a-modal centered title="复制门店日历" :width="680" :visible="visibleCopy" @cancel="closeCopy" @ok="copyShopCalendar">
                <a-alert message="请选择门店和时间段进行复制，操作后该门店在所选时间段内的日期类型将同步至当前门店。" type="warning" show-icon />
                <a-form :form="form" class="mt24">
                    <a-form-item label="门店" required :labelCol="{span: 5}" :wrapperCol="{span: 12}">
                        <a-select allowClear placeholder="请选择" v-decorator="['sourceShopId',{rules: [{required: true, message: '请选择门店'}]}]">
                            <a-select-option v-for="item in shopList" :value="item.id" :key="item.id">{{item.name}}</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="起止日期" :labelCol="{span: 5}" :wrapperCol="{span: 12}">
                        <a-range-picker v-decorator="['date',{rules: [{required: true, message: '请选择起止日期'}]}]" />
                    </a-form-item>
                </a-form>
            </a-modal>
        </content-view>
        <router-view></router-view>
    </div>
</template>
<script>

    const columns = [
        {
            title: "门店",
            width: 220,
            dataIndex: "shopName"
        },
        {
            title: "日期类型",
            width: 100,
            dataIndex: "dateLevel",
            scopedSlots: { customRender: "dateLevel" }
        },
        {
            title: "操作",
            dataIndex: "action",
            scopedSlots: { customRender: "action" }
        }
    ];
import { mapGetters } from "vuex";

export default {
    data() {
        return {
            form: this.$form.createForm(this),
            dataSource: [],
            columns,
            pickerDate: this.$moment(),
            calendarData: [],
            type: 1,
            weekDay: ["日", "一", "二", "三", "四", "五", "六"],
            dateList: [],
            currentYear: this.$moment().year(),
            currentMonth: 1,
            visible: false,
            date: '',
            visibleCopy: false,
            shopList: [],
        }
    },
    computed: {
        ...mapGetters(["shopId"])
    },
    methods: {
		/**
		 *@pickerBtns {method} 日历切换
		*/
		pickerBtns (add) {
            if(this.type == 1) {
                if(add){
                    this.pickerDate = this.$moment(this.pickerDate).add(1,"month")
                }else{
                    this.pickerDate = this.$moment(this.pickerDate).subtract(1,"month")
                }
            }else if(this.type == 2) {
                if(add){
                    this.currentYear ++
                }else{
                    this.currentYear --
                }
            }
            this.getList();
		},
        changeMonth(e) {
            this.pickerDate = e;
            this.getList()
        },
        handleChange(e) {
            this.type = e.target.value;
            this.getList();
        },
		/**
		 *@getListData {method} 添加日历事件
		*/
		getListData(value) {
			let currentItem = this.calendarData.filter(item => value.format("YYYY-MM-DD") === item.date);
			return currentItem ? currentItem : [];
		},
        getList() {
            let date = this.type == 1 ? this.pickerDate.format('YYYY-MM-DD') : this.$moment(this.currentYear + '-01-01').format('YYYY-MM-DD');
            let dateBefore = this.$moment(date).endOf(this.type == 1 ? 'month' : 'year').format('YYYY-MM-DD');
            let dateAfter = this.$moment(date).startOf(this.type == 1 ? 'month' : 'year').format('YYYY-MM-DD');
            this.$api.totalPlatform.getDateList({
                query: {
                    shopId: sessionStorage.getItem('currentShopId'),
                    dateAfter: dateAfter,
                    dateBefore: dateBefore,
                }
            }).then(res => {
                this.calendarData = res;
                if(this.type == 2) {
                    this.initDateList();
                }
            }).catch(err => {
                this.calendarData = [];
                if(this.type == 2) {
                    this.initDateList();
                }
            })
        },
        initDateList() {
            this.dateList = [];
            for(let i = 1; i < 13; i++) {
                this.dateList.push(this.initMonthList(i))
            }
        },
        initMonthList(month) {
            if (month - 1 == 0) {
                var selectDatesYear = this.currentYear * 1 - 1;
                var selectDatesMonth = 12;
            } else {
                var selectDatesYear = this.currentYear;
                var selectDatesMonth =  month * 1 -1;
            }
            const totalDay = new Date(this.currentYear, parseInt(month), 0).getDate();
            const dayOne = new Date(`${this.currentYear}-${month}-01`).getDay();
            const dayLast = new Date(`${this.currentYear}-${month}-${totalDay}`).getDay();
            
            const preLastDay = new Date(selectDatesYear, selectDatesMonth, 0).getDate();
            
            let dateList = this.dateListAdd(1, totalDay, month, this.currentYear);
            let dateList1 = this.dateListAdd(preLastDay - dayOne + 1, preLastDay, selectDatesMonth, selectDatesYear);
            let dateList2 = this.dateListAdd(1, 6 - dayLast, month + 1, selectDatesYear);
            let list = [...dateList1, ...dateList, ...dateList2];
            return list
            
        },
        dateListAdd(startDay, totalDay, month, year) {
            let dateList = [];
            for (let i = startDay; i <= totalDay; i++) {
                let obj = {
                    year,
                    month: month,
                    day: i,
                    week: this.$utils.weekDays(`${year}-${month}-${i}`),
                    dateLevels: {}
                }
                this.calendarData.forEach(item => {
                    if(item.date === `${year}-${this.$utils.toDouble(month)}-${this.$utils.toDouble(i)}`) {
                        obj.dateLevels = item.dateLevels;
                    }
                })
                dateList.push(obj)
            };
            return dateList;
        },
        openModal(date) {
            this.visible = true;
            this.date = date;
            this.getDate();
        },
        selectDate(e) {
            this.openModal(e.format('YYYY-MM-DD'))
        },
        openCopy() {
            this.visibleCopy = true;
        },
        closeCopy() {
            this.visibleCopy = false;
            this.form.resetFields()
        },
        getShopList() {
            this.$api.totalPlatform.selectList().then(res => {
                this.shopList = res.filter(item => item.id != this.shopId);
            });
        },
        copyShopCalendar() {
            let _this = this;
            _this.$confirm({
                title: '是否确认提交？',
                content: '提交后最新的日期类型将立即生效',
                centered: true,
                onOk() {
                    _this.form.validateFields((err, values) => {
                        if (err) return;
                        _this.$api.totalPlatform.copyShopCalendar({
                            query: {
                                sourceShopId: values.sourceShopId,
                                destShopId: _this.shopId,
                                dateAfter: values.date[0].format('YYYY-MM-DD'),
                                dateBefore: values.date[1].format('YYYY-MM-DD'),
                            }
                        }).then(res => {
                            _this.$message.success('操作成功');
                            _this.visibleCopy = false;
                            _this.form.resetFields();
                            _this.getList();
                        });
                    });
                },
                onCancel() {},
            });
        },
        getDate() {
            this.$api.totalPlatform.getDate({
                query: {
                    shopId: this.shopId,
                    date: this.date,
                }
            }).then(res => {
                res.map(item => item.isShow = true)
                this.dataSource = res;
            });
        },
        upDateType(event, row) {
            this.$api.totalPlatform.batchSetDate({
                body: {
                    dateRangeDtos: [{
                        dateLevel: event.target.value,
                        dateStart: row.date,
                        dateEnd: row.date,
                    }],
                    suitShopIdList: [row.shopId]
                }
            }).then(res => {
                this.$message.success('操作成功');
                this.getList();
                this.getDate();
            });
        }
    },
    mounted() {
        this.getList();
        this.getShopList();
    },
    watch: {
        $route(val) {
            val.name == "calendar" && this.getList();
        },
        shopId() {
            this.getList()
        }
    }
}
</script>
<style rel="stylesheet/scss" lang="scss">
.calendar-manger {
    .ant-tag {
        border: none;
        margin-bottom: 4px;
    }
    
	.totalPlatCalender{
		.ant-fullcalendar-header{
			display: none;
		}
	}
    .year-calendar {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        .pay-date {
            width: 32%;
            padding: 24px;
            background: #fff;
            border-radius: 4px;
            &-weekday {
                >span {
                    width: 14.28%;
                    height: 30px;
                }
            }
            &-days {
                background-color: #fff;
                &-item {
                    text-align: center;
                    height: 40px;
                    width: 14.28%;
                    padding: 15px;
                    cursor: pointer;
                    .text-gray {
                        color: #d7d7d7;
                    }
                    >div {
                        width: 24px;
                        margin-top: -5px;
                    }
                    .ant-badge {
                        margin: 0 1px;
                    }
                    .ant-badge-status-text {
                        margin-left: 0;
                    }
                }
            }
        }
    }
}
</style>
